import { types } from 'mobx-state-tree';

export const BreathingSounds = types.model('BreathingSounds', {
  breatheIn: types.maybeNull(types.string),
  breatheOut: types.maybeNull(types.string),
  hold: types.maybeNull(types.string),
});
